// extracted by mini-css-extract-plugin
module.exports = {"container":"personalize_container__2ZHBl","mobile_image":"personalize_mobile_image__1IOSA","text_box":"personalize_text_box__12vgW","image_box":"personalize_image_box__3SHyf"};